import { useState } from 'react';

export default function Features() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const features = [
    {
      title: 'Enhanced Security &',
      subtitle: 'Performance',
      description: 'Our applications combine cutting-edge security protocols with intelligent optimization algorithms. VPN technology ensures encrypted connections while Cleaner tools maintain peak device performance without compromising user privacy.',
      attribution: 'Trusted Technology',
      image: 'https://public.readdy.ai/ai/img_res/15e16d06111fe3c1781db1f8fbac16ec.jpg'
    },
    {
      title: 'Intelligent Optimization &',
      subtitle: 'Speed',
      description: 'Advanced algorithms analyze device usage patterns to provide personalized optimization recommendations. Our Cleaner app identifies unnecessary files and cache data, freeing up valuable storage space while maintaining system stability.',
      attribution: 'Smart Solutions',
      image: 'https://readdy.ai/api/search-image?query=iPhone%20mockup%20showing%20device%20cleaner%20app%20interface%20with%20storage%20optimization%20charts%20and%20performance%20metrics%2C%20modern%20iOS%20design%20with%20green%20and%20teal%20gradient%20colors%2C%20clean%20mobile%20app%20screenshot%2C%20professional%20product%20visualization&width=600&height=800&seq=feature-iphone-cleaner&orientation=portrait'
    },
    {
      title: 'Privacy Protection &',
      subtitle: 'Control',
      description: 'Complete control over your digital footprint with advanced privacy features. Our VPN solutions offer military-grade encryption, no-log policies, and secure server networks across multiple locations for unrestricted, private browsing.',
      attribution: 'Privacy First',
      image: 'https://readdy.ai/api/search-image?query=iPhone%20mockup%20displaying%20privacy%20protection%20app%20with%20lock%20icons%20and%20encrypted%20data%20visualization%2C%20modern%20iOS%20interface%20with%20orange%20and%20red%20gradient%20colors%2C%20professional%20mobile%20security%20app%20screenshot%2C%20high%20quality%20product%20design&width=600&height=800&seq=feature-iphone-privacy&orientation=portrait'
    }
  ];

  const handlePrev = () => {
    setCurrentSlide((prev) => (prev === 0 ? features.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setCurrentSlide((prev) => (prev === features.length - 1 ? 0 : prev + 1));
  };

  return (
    <section id="features" className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-8">
        <div className="flex items-center gap-16">
          <div className="w-[40%]">
            <div className="rounded-[36px] overflow-hidden shadow-2xl bg-gradient-to-br from-purple-100 to-blue-100">
              <img
                src={features[currentSlide].image}
                alt="App Feature"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="w-[60%] pl-16">
            <p className="text-xs font-normal text-[#718096] tracking-widest mb-6">
              (KEY FEATURES)
            </p>

            <h2 className="text-6xl font-bold leading-tight mb-16">
              <div className="text-[#1a202c]">{features[currentSlide].title}</div>
              <div className="mt-2">
                <span className="text-[#a0aec0]">{features[currentSlide].subtitle}</span>
              </div>
            </h2>

            <div className="mb-8">
              <p className="text-lg text-[#2d3748] leading-relaxed max-w-xl">
                "{features[currentSlide].description}"
              </p>
            </div>

            <p className="text-lg font-bold text-[#1a202c] mb-12">
              — {features[currentSlide].attribution}
            </p>

            <div className="flex gap-8">
              <button
                onClick={handlePrev}
                className="w-14 h-14 rounded-full border-2 border-gray-300 flex items-center justify-center text-gray-600 hover:border-gray-400 hover:text-gray-800 transition-all cursor-pointer"
                aria-label="Previous feature"
              >
                <i className="ri-arrow-left-line text-xl"></i>
              </button>
              <button
                onClick={handleNext}
                className="w-14 h-14 rounded-full bg-[#1a202c] flex items-center justify-center text-white hover:bg-[#2d3748] transition-all cursor-pointer"
                aria-label="Next feature"
              >
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}